import { observer } from "mobx-react-lite";
import { MDSLink } from "@/mds";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { windowModule } from "@/modules/window";
import { useAppStore } from "@/store";
import { IntegrationsSenderItemList } from "@/pages/integrations/shared/integrations-list";
import { IntegrationsLoader } from "@/pages/integrations/shared/integrations-loader";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
  SettingsIntegrationBenefitCard,
} from "@/pages/settings/components/settings-integration-layout";

export const SettingsEmailToMemPage = observer(() => {
  const { store } = useAppStore();
  const { verifiedItems, isLoading, load, loadSettings } = store.emailSenders;

  useEffectOnMount(() => {
    load();
    loadSettings();
  });

  const isConnected = verifiedItems.length > 0;

  const benefitPoints = [
    <>
      Forward emails from your verified address to{" "}
      <MDSLink onPress={() => windowModule.openInNewTab({ url: new URL("mailto:save@mem.ai") })}>
        save@mem.ai
      </MDSLink>{" "}
      to automatically create notes
    </>,
    "Works with any type of email: travel confirmations, newsletters, customer correspondence, or anything you want to save",
    "Mem cleans up and summarizes the content into an organized, structured note",
    "The original email is attached to your note for reference",
  ];

  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader
        breadcrumb="Apps and integrations"
        title="Email to Mem"
        isConnected={isConnected}
      />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <SettingsIntegrationBenefitCard points={benefitPoints} />
        </SettingsIntegrationSection>

        <SettingsIntegrationSection>
          {isLoading ? <IntegrationsLoader /> : <IntegrationsSenderItemList />}
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
});
